export const COLORS = {
  // Block categories
  deepWork: '#2b6cb0',
  shallow: '#9f7aea',
  personal: '#38a169',
  meeting: '#ed8936',
  urgent: '#e53e3e',
  buffer: '#718096', // gray - for transition/buffer time

  // UI - Light theme
  light: {
    primary: '#333333',
    background: '#f5f5f0',
    surface: '#ffffff',
    surfaceSecondary: '#fafaf5',
    border: '#999999',
    borderLight: '#cccccc',
    borderDashed: '#999999',
    text: '#333333',
    textSecondary: '#666666',
    textMuted: '#888888',
  },

  // UI - Dark theme
  dark: {
    primary: '#f5f5f0',
    background: '#1a1a18',
    surface: '#222222',
    surfaceSecondary: '#2a2a28',
    border: '#555555',
    borderLight: '#444444',
    borderDashed: '#555555',
    text: '#f5f5f0',
    textSecondary: '#cccccc',
    textMuted: '#888888',
  },

  // Status
  success: '#38a169',
  warning: '#ed8936',
  error: '#e53e3e',

  // Chaos system
  ghost: 'rgba(0,0,0,0.4)',
  ghostDark: 'rgba(255,255,255,0.4)',
  strikethrough: '#c53030',
  currentTime: '#e53e3e',

  // Ritual
  ritualGreen: '#38a169',
  ritualGreenLight: '#68d391',

  // Misc
  annotation: '#ffeb3b',
  fab: '#333333',
  fabDark: '#f5f5f0',
} as const;

export type ColorTheme = 'light' | 'dark';

export const getThemeColors = (theme: ColorTheme) => {
  return theme === 'dark' ? COLORS.dark : COLORS.light;
};
